import React, { useEffect, useState } from "react"
import { useAuthUser } from "react-auth-kit"
import { useParams } from "react-router-dom"
import CancelOrder from "../../components/orders/CancelOrder.jsx"
import Overlay from "../../components/Overlay"

const HomePage = () => {
	const { id } = useParams()
	const [isOpen, setIsOpen] = useState(false)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)
	const [order, setOrder] = useState([])
	const auth = useAuthUser()
	const user = auth()
	const [baseURL] = useState(`https://api.baobabcircle.com/pharmacy/orders/u`)

	const [register] = useState("Fetching Data")
	const [attendanceColor] = useState("#d1d1d1")
	useEffect(() => {
		setLoading(true)
		fetch(`${baseURL}/${id}`, {
			method: "GET",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				Authorization: `Bearer ${user.apikey}`,
				// Authorization: `Bearer zmsBkCwHuLVZIfJ2GA3sYdwZc1bqRvP9fLMqlHA3rPsPiYSwcRjW8mGY9MRKH0Kw`,
			},
		})
			.then((response) => response.json())
			.then((result) => {
				if (result.error) {
					setLoading(false)
					setError(result.error)
					return
				} else if (result.data === null) {
					setLoading(false)
					setError("Order not found")
					return
				} else if (result.data === undefined) {
					setLoading(false)
					setError("Order not found")
					return
				} else if (result.data === "") {
					setLoading(false)
					setError("Order not found")
					return
				} else {
					setOrder(result.data)
					setLoading(false)
				}
			})
			.catch((error) => {
				setError(error)
				console.log(error)
			})
	}, [baseURL, id, user.apikey])
	useEffect(() => {
		return function () {
			window.scrollTo(0, 0)
		}
	}, [])

	return (
		<section className="max-w-[1090px] w-full mx-auto px-[19px] sm:grid sm:pb-[80px] relative">
			<div className="flex justify-between py-[19px]">
				<div className="">
					<div className="text-[20px] font-bold">Order #{id}</div>
					<div
						className="text-[13px] mt-[3px]"
						style={{ color: attendanceColor }}
					>
						{register}
					</div>
				</div>
			</div>
			{loading && (
				<div className="grid mx-auto">
					<svg
						className="h-[1.88rem] w-[1.5rem] m-auto"
						version="1.1"
						id="loader-1"
						xmlns="http://www.w3.org/2000/svg"
						x="0px"
						y="0px"
						width="2.50rem"
						height="2.50rem"
						viewBox="0 0 40 40"
						enableBackground="new 0 0 40 40"
					>
						<path
							opacity="0.2"
							d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
						/>
						<path
							d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
C22.32,8.481,24.301,9.057,26.013,10.047z"
						>
							<animateTransform
								attributeType="xml"
								attributeName="transform"
								type="rotate"
								from="0 20 20"
								to="360 20 20"
								dur="0.5s"
								repeatCount="indefinite"
							/>
						</path>
					</svg>
				</div>
			)}
			{!loading && !error && (
				<>
					<div className="bg-white p-[19px] grid gap-[14px] rounded-[2px] mt-[19px] w-full flex-grow">
						<div className="flex justify-between">
							<div className="text-[17px] font-medium">
								Order Information
							</div>
						</div>
						<div className="border-t-[1px] border-[#fff5eb] h-full grow-[1]"></div>
						<div className="flex flex-col gap-[5px] border-b-[1px] border-[#fff5eb] w-full">
							<div className="pb-[10px] pt-[5px] grid md:grid-cols-3 gap-[1rem]">
								<div className="flex flex-col gap-[7px]">
									<div className="text-[12px] leading-[1] text-[#6C6C6C]">
										Order Status
									</div>
									<div className="text-[14px] leading-[1]">
										{order?.status}
									</div>
								</div>
								<div className="flex flex-col gap-[7px]">
									<div className="text-[12px] leading-[1] text-[#6C6C6C]">
										Created By
									</div>
									<div className="text-[14px] leading-[1]">
										{order?.createdBy?.firstName}{" "}
										{order?.createdBy?.lastName}
									</div>
								</div>
							</div>
						</div>
						<div className="flex flex-col gap-[5px] border-b-[1px] border-[#fff5eb] w-full">
							<h4 className="text-[14px] font-medium">
								Patient Details
							</h4>
							<div className="pb-[10px] pt-[5px] grid md:grid-cols-3 gap-[1rem]">
								<div className="flex flex-col gap-[7px]">
									<div className="text-[12px] leading-[1] text-[#6C6C6C]">
										Patient Name
									</div>
									<div className="text-[14px] leading-[1]">
										{order?.patient?.firstName}{" "}
										{order?.patient?.lastName}
									</div>
								</div>
								<div className="flex flex-col gap-[7px]">
									<div className="text-[12px] leading-[1] text-[#6C6C6C]">
										Phone
									</div>
									<div className="text-[14px] leading-[1]">
										{order?.patient?.phone}
									</div>
								</div>
							</div>
						</div>
						<div className="flex flex-col gap-[5px] border-b-[1px] border-[#fff5eb] w-full">
							<h4 className="text-[14px] font-medium">
								Order Details
							</h4>
							<div className="pb-[10px] pt-[5px] grid gap-[1rem] md:grid-cols-3">
								<div className="flex flex-col gap-[7px]">
									<div className="text-[12px] leading-[1] text-[#6C6C6C]">
										Delivery Address
									</div>
									<div className="text-[14px] capitalize leading-[1.5] line-clamp-2">
										{order?.deliveryAddress}
									</div>
								</div>
								<div className="flex flex-col gap-[7px]">
									<div className="text-[12px] leading-[1] text-[#6C6C6C]">
										City
									</div>
									<div className="text-[14px] leading-[1]">
										{order?.city}
									</div>
								</div>
								<div className="flex flex-col gap-[7px]">
									<div className="text-[12px] leading-[1] text-[#6C6C6C]">
										Estimated Delivery Time
									</div>
									<div className="text-[14px] leading-[1]">
										{order?.estimatedDeliveryTime}
									</div>
								</div>
							</div>
						</div>
						<div className="flex flex-col gap-[5px] border-b-[1px] border-[#fff5eb] w-full">
							<h4 className="text-[14px] font-medium">
								CHE Delivery Details
							</h4>
							<div className="pb-[10px] pt-[5px] grid gap-[1rem] md:grid-cols-3">
								<div className="flex flex-col gap-[7px]">
									<div className="text-[12px] leading-[1] text-[#6C6C6C]">
										Code
									</div>
									<div className="text-[14px] leading-[1] line-clamp-1">
										{order?.che?.cheCode}
									</div>
								</div>
								<div className="flex flex-col gap-[7px]">
									<div className="text-[12px] leading-[1] text-[#6C6C6C]">
										Name
									</div>
									<div className="text-[14px] leading-[1]">
										{order?.che?.firstName}{" "}
										{order?.che?.lastName}
									</div>
								</div>
								<div className="flex flex-col gap-[7px]">
									<div className="text-[12px] leading-[1] text-[#6C6C6C]">
										Phone
									</div>
									<div className="text-[14px] leading-[1]">
										{order?.che?.phone}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="bg-white p-[19px] grid gap-[14px] rounded-[2px] mt-[19px] w-full flex-grow">
						<div className="flex justify-between">
							<div className="text-[17px] font-medium">
								Medication
							</div>
						</div>
						<div className="border-t-[1px] border-[#fff5eb] h-full grow-[1]"></div>
						<div>
							<ul className="grid gap-[5px] md:gap-[10px]">
								<li className="md:grid-cols-[1fr_1fr_90px] justify-between items-center  border-b-[1px] border-[#fff5eb] pb-[5px] text-[#6C6C6C] grid gap-[10px] grid-cols-[1fr_60px_90px]">
									<div className="text-[14px]">Name</div>
									<div className="text-[14px]">Quantity</div>
									<div className="text-[14px]">Amount</div>
								</li>
								{order?.medication?.map((item, index) => (
									<li
										key={index}
										className="md:grid-cols-[1fr_1fr_90px] pb-[5px] grid gap-[10px] border-b-[1px] border-[#fff5eb] grid-cols-[1fr_60px_90px] justify-between items-center"
									>
										<div className="text-[14px]">
											{item.name}
										</div>
										<div className="text-[14px]">
											{item.quantity}
										</div>
										<div className="text-[14px]">
											{item.currency}{" "}
											{item.subtotal.toFixed(2)}
										</div>
									</li>
								))}
							</ul>
							<div className="  items-center mt-[10px]  grid gap-[10px] grid-cols-[1fr_90px]">
								<div className="text-[14px] font-medium">
									Delivery
								</div>
								<div className="text-[14px]">
									KES {order?.deliveryCost}
								</div>
							</div>
							<div className="items-center mt-[5px]   grid gap-[10px] grid-cols-[1fr_90px]">
								<div className="text-[14px] font-medium">
									Total
								</div>
								<div className="text-[14px]">
									KES {order?.total}
								</div>
							</div>
						</div>
					</div>
					{order?.cancellationReason && (
						<div className="bg-white p-[19px] grid gap-[14px] rounded-[2px] mt-[19px] w-full flex-grow">
							<div className="flex justify-between">
								<div className="text-[17px] font-medium">
									More Information
								</div>
							</div>
							<div className="border-t-[1px] border-[#fff5eb] h-full grow-[1]"></div>
							<div>
								<div className="  items-center mt-[10px]  grid gap-[10px] grid-cols-[1fr_90px]">
									{order?.cancellationReason && (
										<div className="text-[14px]">
											Order was cancelled because:{" "}
											{order?.cancellationReason}
										</div>
									)}
									{order?.rejectionReason && (
										<div className="text-[14px]">
											Order was rejected because:{" "}
											{order?.rejectionReason}
										</div>
									)}
								</div>
							</div>
						</div>
					)}
					<div className="flex md:flex-row gap-[15px] mt-[14px] ">
						{(order?.status === "NEW" ||
							order?.status === "ACCEPTED") && (
							<button
								onClick={() => setIsOpen(true)}
								type="button"
								className="text-white bg-[#FF7373] sm:w-full  rounded-[3px] flex h-[32px] px-[1rem] mt-[10px]"
							>
								<span className="m-auto flex justify-center gap-[0.2rem]">
									<span className="text-[12px]">
										Cancel Order
									</span>
								</span>
							</button>
						)}
					</div>
				</>
			)}

			{!loading && error && (
				<div className="bg-white p-[19px] grid gap-[14px] rounded-[2px] mt-[19px] w-full flex-grow">
					<div className="flex justify-between">
						<div className="text-[17px] font-medium">
							Order Notice
						</div>
					</div>
					<div className="border-t-[1px] border-[#fff5eb] h-full grow-[1]"></div>
					<div className="text-[14px]">{error}</div>
				</div>
			)}

			{/* Cancel Order Modal */}

			<CancelOrder
				isOpen={isOpen}
				onClose={() => setIsOpen(false)}
				id={id}
			/>

			<Overlay
				isOpen={isOpen}
				onClose={() => {
					setIsOpen(false)
				}}
			/>
		</section>
	)
}
export default HomePage
